import React from 'react';

/**
 * Mirrors the "Design selected" banner on ProductCatalogPage.
 * Use when the user chose a product first and is picking an image (e.g. gallery).
 *
 * @param {object|null} selectedProduct - Catalog row from navigation state (must include at least `name`, usually `image`).
 * @param {string|null|undefined} productImageUrl - Optional higher-res URL (e.g. from GET /products/:id/details); falls back to selectedProduct.image.
 */
export default function ProductSelectionFlowBanner({ selectedProduct, productImageUrl }) {
  if (!selectedProduct) return null;
  const thumb =
    productImageUrl ||
    selectedProduct.image ||
    selectedProduct.thumbnail ||
    selectedProduct.preview_image ||
    '';
  const name = selectedProduct.name || 'Product';

  return (
    <div
      className="mb-4 max-w-4xl mx-auto rounded-xl border border-sky-200 bg-sky-50/90 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 shadow-sm"
      role="status"
    >
      {thumb ? (
        <img
          src={thumb}
          alt=""
          className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg object-contain border border-white shadow-sm flex-shrink-0 bg-white p-0.5"
        />
      ) : (
        <div
          className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg border border-dashed border-sky-300 bg-white/80 flex-shrink-0 flex items-center justify-center text-[10px] text-sky-700 text-center px-1 leading-tight"
          aria-hidden
        >
          No preview
        </div>
      )}
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-gray-900">
          Selected Product: <span className="text-sky-950">{name}</span>
        </p>
        <p className="text-sm text-gray-600 mt-1">Now pick a ready-made design to place on this product. No account needed.</p>
      </div>
    </div>
  );
}
